import React, { Component } from "react";
import { BrowserRouter, Switch, Route, Link } from "react-router-dom";
import Navbar from "./components/layout/Navbar";
import Dashboard from "./components/dashboard/Dashboard";
// import ProjectDetails from './components/projects/ProjectDetails'
// import SignIn from './components/auth/SignIn'
// import SignUp from './components/auth/SignUp'
import NewWord from "./components/dashboard/NewWord";
import WordCard from "./components/words/WordCard";
import EditExistingWord from "./components/dashboard/EditExistingWord";
import VerbCard from "./components/cards/VerbCard";
import NewVerb from "./components/cards/NewVerb";
import EditVerb from "./components/cards/EditVerb";
import csv from "./components/csv/csv";
import csvGoogle from "./components/csv/csvGoogle";
import SignUp from "./components/auth/SignUp";
import SignIn from "./components/auth/SignIn";
import Grammar from "./components/grammar/Grammar";
import HtmlScrape from "./components/dict/HtmlScrape";
import HtmlFrame from "./components/dict/HtmlFrame";
import IframeTest from "./components/shared/IframeTest";
import FullHeight from "./components/shared/FullHeight";
import Gender from "./components/gender/Gender";
import AddGender from "./components/gender/AddGender";

class App extends Component {
  render() {
    var prevScrollpos = window.pageYOffset;

    // document.addEventListener("scroll", function (e) {
    //   // console.log("scroll");
    // });

    // window.onscroll = function () {
    //   var currentScrollPos = window.pageYOffset;
    //   if (prevScrollpos > currentScrollPos) {
    //     document.getElementById("navbar").style.top = "0";
    //   } else {
    //     document.getElementById("navbar").style.top = "-50px";
    //   }
    //   prevScrollpos = currentScrollPos;
    // };

    return (
      <BrowserRouter>
        <div className="App">
          <Navbar />
          <Switch>
            <Route exact path="/" component={Dashboard} />
            <Route path="/create" component={NewWord} />
            <Route path="/edit" component={EditExistingWord} />
            <Route path="/card" component={VerbCard} />
            <Route path="/wordcard" component={WordCard} />
            <Route path="/newverb" component={NewVerb} />
            <Route path="/csv" component={csv} />
            <Route path="/csvGoogle" component={csvGoogle} />
            <Route path="/signup" component={SignUp} />
            <Route path="/signin" component={SignIn} />
            <Route path="/editverb" component={EditVerb} />
            <Route path="/grammar" component={Grammar} />
            <Route path="/htmlScrape" component={HtmlScrape} />
            <Route path="/htmlFrame" component={HtmlFrame} />
            <Route path="/iframe" component={FullHeight} />
            <Route path="/gender" component={Gender} />
            <Route path="/addgender" component={AddGender} />
            <Route
              path="/edit1"
              render={(props) => <EditExistingWord {...props} propDummy={50} />}
            />

            {/* <Link to={{
      pathname: '/edit',
      search: '?query=abc',
      state: { detail: "50" }
    }}> My Link </Link> */}
            {/* <Route path='/edit' state="" component={EditExistingWord} /> */}
          </Switch>
        </div>
      </BrowserRouter>
    );
  }
}

export default App;
